var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "#D32E2A",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.12109 10.2764H7.28027L7 3.55664H8.40137L8.12109 10.2764ZM7 11.7461C7 11.5319 7.06152 11.361 7.18457 11.2334C7.31217 11.1058 7.48307 11.042 7.69727 11.042C7.91146 11.042 8.08236 11.1058 8.20996 11.2334C8.33757 11.361 8.40137 11.5319 8.40137 11.7461C8.40137 11.9603 8.33757 12.1312 8.20996 12.2588C8.08236 12.3818 7.91146 12.4434 7.69727 12.4434C7.48307 12.4434 7.31217 12.3818 7.18457 12.2588C7.06152 12.1312 7 11.9603 7 11.7461Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAlert);
export default __webpack_public_path__ + "static/media/icon-alert.8cf6f758c969c04b75a87a3070b44d2a.svg";
export { ForwardRef as ReactComponent };